interface AuditEntry {
  time: string;
  tag: "ai" | "human";
  tagLabel: string;
  title: string;
  meta: string;
}

const ENTRIES: AuditEntry[] = [
  {
    time: "25 jun 2026 · 14:32",
    tag: "human",
    tagLabel: "Mens",
    title: "Secretariaat bevestigde gereedheid (EA-2026-043)",
    meta: "Actor: Secretariaat · Lien Maes · Dossier doorgezet naar Bureau-agenda 2 jul",
  },
  {
    time: "25 jun 2026 · 11:17",
    tag: "ai",
    tagLabel: "AI",
    title: "Pre-screening uitgevoerd (EA-2026-042)",
    meta: "3 issues gevonden (2 hoog, 1 midden) · Zekerheid: 87% · Onderzoeker op de hoogte gesteld · Bron: formulier p.4–6",
  },
  {
    time: "25 jun 2026 · 10:54",
    tag: "human",
    tagLabel: "Mens",
    title: "Reviewer wees AI-issue af (EA-2026-034)",
    meta: 'Actor: Prof. Verstraeten · Issue "methodologie onduidelijk" gemarkeerd als niet-relevant · Reden: "Onderdeel is besproken buiten het formulier"',
  },
  {
    time: "25 jun 2026 · 09:03",
    tag: "ai",
    tagLabel: "AI",
    title: "Reviewer briefing gegenereerd (EA-2026-038)",
    meta: "Secties: dossiersamenvatting, deelnemersprofiel, dataverwerkingsplan, openstaande caveats · Zekerheid: 91%",
  },
  {
    time: "24 jun 2026 · 16:45",
    tag: "human",
    tagLabel: "Mens",
    title: "Onderzoeker herzien en opnieuw ingediend (EA-2026-043)",
    meta: "Actor: Lien Maes · 2 issues opgelost · GDPR-sectie aangevuld · Informed consent bijgevoegd",
  },
  {
    time: "24 jun 2026 · 14:20",
    tag: "human",
    tagLabel: "Mens",
    title: "Menselijke review aangevraagd (EA-2026-031)",
    meta: 'Actor: Kevin De Smedt · Reden: "AI-bevinding over kwetsbare doelgroep is niet van toepassing op onze studie" · Secretariaat op de hoogte gesteld',
  },
  {
    time: "24 jun 2026 · 11:08",
    tag: "ai",
    tagLabel: "AI",
    title: "Pre-screening uitgevoerd (EA-2026-041)",
    meta: "5 issues gevonden (3 hoog, 1 midden, 1 laag) · Zekerheid: 79% · Verouderd template gedetecteerd · Bron: aanvraagformulier.docx",
  },
  {
    time: "23 jun 2026 · 15:30",
    tag: "human",
    tagLabel: "Mens",
    title: "Bureau gaf positief advies (EA-2026-039)",
    meta: "Actor: Bureau EA SHW · Voorzitter ondertekend · Communicatie verstuurd door secretariaat",
  },
];

export function AuditPage() {
  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Audit trail</h1>
          <p>Automatisch log van AI-acties, menselijke beslissingen en statuswijzigingen</p>
        </div>
        <button className="btn btn--ghost">Exporteer log</button>
      </div>
      <div className="info-banner info-banner--navy">
        <span className="info-banner__icon">🔒</span>
        <span>
          Elke AI-actie wordt gelogd met bronverwijzing, zekerheidsgraad en menselijke override.
          Menselijke beslissingen overschrijven altijd AI-uitkomsten.
        </span>
      </div>
      <div className="card ua-mt-space">
        <div className="card__body p-0">
          <div className="audit-log">
            {ENTRIES.map((entry, idx) => (
              <div key={idx} className="audit-entry">
                <div className="audit-entry__time">{entry.time}</div>
                <div className="audit-entry__body">
                  <span className={`audit-tag audit-tag--${entry.tag}`}>{entry.tagLabel}</span>
                  <div>
                    <div className="audit-entry__title">{entry.title}</div>
                    <div className="audit-entry__meta">{entry.meta}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="ua-pager-info flex justify-between">
          <span>1–8 van 347 events · Periode: afgelopen 30 dagen</span>
          <a href="#">Toon ouder log</a>
        </div>
      </div>
    </section>
  );
}
